/** 任务方案未指定具体合同类别时，交由合同快速预审识别。 */
export const SYSTEM_AUTO_CONTRACT_TYPE = '系统自动识别的合同类型';

export const CONSTRUCTION_SERIES_CONTRACT_TYPE = '建设工程系列合同';

/** 买卖合同系列（设置页选项名）。 */
export const SALE_SERIES_CONTRACT_TYPE = '买卖合同系列';

/** 租赁与融资租赁系列（设置页选项名）。 */
export const LEASE_SERIES_CONTRACT_TYPE = '租赁与融资租赁系列';

/** 承揽、技术与服务合同系列（设置页选项名）。 */
export const SERVICE_SERIES_CONTRACT_TYPE = '承揽、技术与服务合同系列';

/** 委托及经营管理合同系列（设置页选项名）。 */
export const MANDATE_SERIES_CONTRACT_TYPE = '委托及经营管理合同系列';

/** 融资与担保合同系列（设置页选项名）。 */
export const FINANCE_SERIES_CONTRACT_TYPE = '融资与担保合同系列';

/** 运输、保管与仓储合同系列（设置页选项名）。 */
export const LOGISTICS_SERIES_CONTRACT_TYPE = '运输、保管与仓储合同系列';

/** 特别法合同系列（设置页选项名）。 */
export const SPECIAL_LAW_SERIES_CONTRACT_TYPE = '特别法合同系列';

/** 其他或混合合同（设置页选项名）。 */
export const OTHER_MIXED_SERIES_CONTRACT_TYPE = '其他或混合合同';

/**
 * 非合同文件（设置页选项名）。
 * 情况报告、函件、制度草案、法律意见书等不以缔约给付为核心的文书。
 */
export const NON_CONTRACT_DOCUMENT_SERIES = '非合同文件';

/**
 * 股权交易与公司治理系列（设置页选项名）。
 * 含原「股权交易与公司投融资」「公司治理协议」「合伙合同」三个系列。
 */
export const EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE = '股权交易与公司治理系列';

/** @deprecated 已并入 EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE，保留供历史数据映射。 */
export const GOVERNANCE_SERIES_CONTRACT_TYPE = EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE;

/** 商品房买卖常见具体类型名（归入买卖合同系列）。 */
export const COMMERCIAL_HOUSING_CONTRACT_TYPE_LABELS = [
  '商品房买卖合同',
  '商品房预售合同',
  '商品房销售合同',
  '购房合同',
] as const;

/** 项目/任务设置中的合同类型系列选项（与界面下拉一致）。 */
export const CONTRACT_TYPE_SERIES_OPTIONS = [
  '买卖合同系列',
  EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  CONSTRUCTION_SERIES_CONTRACT_TYPE,
  '租赁与融资租赁系列',
  SERVICE_SERIES_CONTRACT_TYPE,
  MANDATE_SERIES_CONTRACT_TYPE,
  FINANCE_SERIES_CONTRACT_TYPE,
  LOGISTICS_SERIES_CONTRACT_TYPE,
  SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  OTHER_MIXED_SERIES_CONTRACT_TYPE,
  NON_CONTRACT_DOCUMENT_SERIES,
] as const;

/** 历史保存值 → 系列。 */
export const LEGACY_CONTRACT_TYPE_TO_SERIES: Record<string, string> = {
  '采购合同': '买卖合同系列',
  '销售合同': '买卖合同系列',
  '服务合同': SERVICE_SERIES_CONTRACT_TYPE,
  '承揽合同': SERVICE_SERIES_CONTRACT_TYPE,
  '加工合同': SERVICE_SERIES_CONTRACT_TYPE,
  '定作合同': SERVICE_SERIES_CONTRACT_TYPE,
  '技术开发合同': SERVICE_SERIES_CONTRACT_TYPE,
  '技术转让合同': SERVICE_SERIES_CONTRACT_TYPE,
  '技术许可合同': SERVICE_SERIES_CONTRACT_TYPE,
  '技术咨询合同': SERVICE_SERIES_CONTRACT_TYPE,
  '技术服务合同': SERVICE_SERIES_CONTRACT_TYPE,
  '软件开发合同': SERVICE_SERIES_CONTRACT_TYPE,
  '咨询合同': SERVICE_SERIES_CONTRACT_TYPE,
  '服务外包合同': SERVICE_SERIES_CONTRACT_TYPE,
  '委托合同': MANDATE_SERIES_CONTRACT_TYPE,
  '委托经营合同': MANDATE_SERIES_CONTRACT_TYPE,
  '行纪合同': MANDATE_SERIES_CONTRACT_TYPE,
  '中介合同': MANDATE_SERIES_CONTRACT_TYPE,
  '居间合同': MANDATE_SERIES_CONTRACT_TYPE,
  '托管合同': MANDATE_SERIES_CONTRACT_TYPE,
  '资产托管合同': MANDATE_SERIES_CONTRACT_TYPE,
  '企业托管合同': MANDATE_SERIES_CONTRACT_TYPE,
  '运输合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '货物运输合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '货运合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '货运代理合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '客运合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '多式联运合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '保管合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '仓储合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '物流合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '物流服务合同': LOGISTICS_SERIES_CONTRACT_TYPE,
  '代理经营合同': MANDATE_SERIES_CONTRACT_TYPE,
  '借款合同': FINANCE_SERIES_CONTRACT_TYPE,
  '贷款合同': FINANCE_SERIES_CONTRACT_TYPE,
  '保证合同': FINANCE_SERIES_CONTRACT_TYPE,
  '抵押合同': FINANCE_SERIES_CONTRACT_TYPE,
  '最高额抵押合同': FINANCE_SERIES_CONTRACT_TYPE,
  '质押合同': FINANCE_SERIES_CONTRACT_TYPE,
  '股权质押合同': FINANCE_SERIES_CONTRACT_TYPE,
  '保理合同': FINANCE_SERIES_CONTRACT_TYPE,
  '独立保函': FINANCE_SERIES_CONTRACT_TYPE,
  '租赁合同': LEASE_SERIES_CONTRACT_TYPE,
  '房屋租赁合同': LEASE_SERIES_CONTRACT_TYPE,
  '融资租赁合同': LEASE_SERIES_CONTRACT_TYPE,
  '售后回租合同': LEASE_SERIES_CONTRACT_TYPE,
  '保密协议': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '保密合同': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  'NDA': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '劳动人事协议': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '劳动合同': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '聘用协议': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '劳务派遣协议': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '劳务派遣合同': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '竞业限制协议': SPECIAL_LAW_SERIES_CONTRACT_TYPE,
  '其他合同': OTHER_MIXED_SERIES_CONTRACT_TYPE,
  '无名合同': OTHER_MIXED_SERIES_CONTRACT_TYPE,
  '和解协议': OTHER_MIXED_SERIES_CONTRACT_TYPE,
  '调解协议': OTHER_MIXED_SERIES_CONTRACT_TYPE,
  '意向书': OTHER_MIXED_SERIES_CONTRACT_TYPE,
  '合作备忘录': OTHER_MIXED_SERIES_CONTRACT_TYPE,
  '商品房买卖合同': SALE_SERIES_CONTRACT_TYPE,
  '商品房预售合同': SALE_SERIES_CONTRACT_TYPE,
  '商品房销售合同': SALE_SERIES_CONTRACT_TYPE,
  '购房合同': SALE_SERIES_CONTRACT_TYPE,
  '二手房买卖合同': SALE_SERIES_CONTRACT_TYPE,
  '存量房买卖合同': SALE_SERIES_CONTRACT_TYPE,
  '设备买卖合同': SALE_SERIES_CONTRACT_TYPE,
  '进出口买卖合同': SALE_SERIES_CONTRACT_TYPE,
  '跨境货物买卖合同': SALE_SERIES_CONTRACT_TYPE,
  '股权交易与公司投融资系列': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '公司治理协议系列': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '合伙合同系列': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '公司治理协议': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '股权交易与公司投融资合同': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '合伙合同': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '股东协议': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '公司章程': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '股权转让合同': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '股份转让合同': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '股份有限公司股份转让合同': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
  '增资协议': EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
};

const CONSTRUCTION_TYPE_PATTERN = /建设工程系列合同|建设工程|施工合同|工程总承包|专业分包|劳务分包|勘察合同|设计合同|监理合同|项目管理合同|EPC|总承包合同/iu;

const SERIES_KEYWORD_RULES: Array<{series: string; patterns: RegExp[]}> = [
  {series: CONSTRUCTION_SERIES_CONTRACT_TYPE, patterns: [CONSTRUCTION_TYPE_PATTERN]},
  {series: FINANCE_SERIES_CONTRACT_TYPE, patterns: [/股权质押/u, /股票质押/u, /权利质押/u]},
  {
    series: EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE,
    patterns: [
      /股东协议/u, /公司章程/u, /公司治理/u, /表决权委托/u, /一致行动/u, /保留事项/u, /一票否决/u, /僵局/u,
      /股权转让/u, /股份转让/u, /股份有限公司股份/u, /产权转让/u, /国有产权/u, /产权交易/u,
      /增资/u, /对赌/u, /并购/u, /投融资/u, /认购协议/u, /投资协议/u,
      /合伙合同/u, /合伙协议/u, /合伙企业/u, /有限合伙/u,
      /股权协议/u,
    ],
  },
  {series: '租赁与融资租赁系列', patterns: [/租赁/u, /融资租赁/u, /出租/u, /承租/u]},
  {series: FINANCE_SERIES_CONTRACT_TYPE, patterns: [
    /借款合同/u, /借款协议/u, /民间借贷/u, /贷款合同/u, /贷款协议/u,
    /保证合同/u, /最高额保证/u,
    /抵押合同/u, /最高额抵押/u, /不动产抵押/u,
    /质押合同/u, /动产质押/u,
    /保理合同/u, /保理协议/u,
    /独立保函/u, /见索即付/u, /银行保函/u,
    /担保合同/u,
    /融资合同/u, /融资协议/u,
  ]},
  {series: LOGISTICS_SERIES_CONTRACT_TYPE, patterns: [
    /货物运输合同/u, /货运合同/u, /货运代理合同/u, /客运合同/u, /多式联运合同/u, /运输合同/u,
    /保管合同/u, /仓储合同/u, /仓储保管合同/u,
    /物流服务合同/u, /综合物流合同/u, /物流合同/u,
  ]},
  {series: MANDATE_SERIES_CONTRACT_TYPE, patterns: [/委托合同/u, /委托经营/u, /行纪合同/u, /中介合同/u, /居间合同/u, /资产托管/u, /物业托管/u, /企业托管/u, /托管合同/u, /经营管理/u, /代理经营/u]},
  {series: SALE_SERIES_CONTRACT_TYPE, patterns: [/商品房买卖/u, /商品房预售/u, /商品房销售/u, /购房合同/u, /商品住宅/u, /现房销售/u]},
  {series: SALE_SERIES_CONTRACT_TYPE, patterns: [/二手房/u, /存量房/u, /存量住房/u]},
  {series: SALE_SERIES_CONTRACT_TYPE, patterns: [/跨境/u, /进出口/u, /国际贸易/u, /外贸合同/u, /\bFOB\b/i, /\bCIF\b/i]},
  {series: SALE_SERIES_CONTRACT_TYPE, patterns: [/设备买卖/u, /机器设备/u, /机电设备/u, /进口设备/u]},
  {series: SALE_SERIES_CONTRACT_TYPE, patterns: [/买卖合同/u, /采购合同/u, /销售合同/u, /购销/u, /供货/u, /物资采购/u]},
  {series: OTHER_MIXED_SERIES_CONTRACT_TYPE, patterns: [/权利义务转让/u, /权利义务概括转让/u, /债权债务转让/u, /债权债务概括转让/u, /合同权利义务转让/u]},
  {series: SERVICE_SERIES_CONTRACT_TYPE, patterns: [/服务外包/u, /外包合同/u, /岗位外包/u, /人事服务/u, /人力资源服务/u, /承揽/u, /物业服务/u, /服务合同/u, /服务协议/u, /技术服务/u, /技术开发/u, /委托开发/u, /合作开发/u, /技术转让/u, /技术许可/u, /技术咨询/u, /咨询合同/u, /软件开发/u, /外包/u, /研发/u, /运维/u]},
  {series: SPECIAL_LAW_SERIES_CONTRACT_TYPE, patterns: [
    /劳动合同/u, /聘用协议/u, /劳动人事/u, /劳务派遣协议/u, /劳务派遣合同/u,
    /竞业限制协议/u, /竞业禁止协议/u,
    /保密协议/u, /保密合同/u, /\bnda\b/i,
  ]},
];

/**
 * 是否属于股权交易与公司治理系列（含投融资、治理协议、合伙）。
 */
export function isEquityGovernanceSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE;
}

/** @deprecated 使用 isEquityGovernanceSeriesLabel。 */
export function isGovernanceContractSeriesLabel(type: string): boolean {
  return isEquityGovernanceSeriesLabel(type);
}

export function isSaleContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === SALE_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === SALE_SERIES_CONTRACT_TYPE;
}

/** 是否属于租赁与融资租赁系列。 */
export function isLeaseContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === LEASE_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === LEASE_SERIES_CONTRACT_TYPE;
}

/** 是否属于承揽、技术与服务合同系列。 */
export function isServiceContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === SERVICE_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === SERVICE_SERIES_CONTRACT_TYPE;
}

/** 是否属于委托及经营管理合同系列。 */
export function isMandateContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === MANDATE_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === MANDATE_SERIES_CONTRACT_TYPE;
}

/** 是否属于融资与担保合同系列。 */
export function isFinanceContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === FINANCE_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === FINANCE_SERIES_CONTRACT_TYPE;
}

/** 是否属于运输、保管与仓储合同系列。 */
export function isLogisticsContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === LOGISTICS_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === LOGISTICS_SERIES_CONTRACT_TYPE;
}

/** 是否属于特别法合同系列。 */
export function isSpecialLawContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === SPECIAL_LAW_SERIES_CONTRACT_TYPE) return true;
  return resolveContractTypeSeries(value) === SPECIAL_LAW_SERIES_CONTRACT_TYPE;
}

/** 是否属于其他或混合合同。 */
export function isOtherMixedContractSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (isNonContractDocumentSeriesLabel(value)) return false;
  if (value === OTHER_MIXED_SERIES_CONTRACT_TYPE || value === '其他合同') return true;
  return resolveContractTypeSeries(value) === OTHER_MIXED_SERIES_CONTRACT_TYPE;
}

/** 是否属于非合同文件（法规/内规合规审路径，不套用合同专项规则）。 */
export function isNonContractDocumentSeriesLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if (value === NON_CONTRACT_DOCUMENT_SERIES) return true;
  return resolveContractTypeSeries(value) === NON_CONTRACT_DOCUMENT_SERIES;
}

/** 是否为商品房买卖合同类具体类型名称。 */
export function isCommercialHousingContractLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  if ((COMMERCIAL_HOUSING_CONTRACT_TYPE_LABELS as readonly string[]).includes(value)) return true;
  return /商品房|购房合同|商品住宅/u.test(value);
}

export function isConstructionContractTypeLabel(type: string): boolean {
  const value = String(type ?? '').trim();
  if (!value) return false;
  return CONSTRUCTION_TYPE_PATTERN.test(value);
}

/**
 * 将识别出的具体合同类型映射到系列分类。
 */
export function resolveContractTypeSeries(recognizedType: string): string {
  const value = String(recognizedType ?? '').trim();
  if (!value || value === SYSTEM_AUTO_CONTRACT_TYPE) return '';
  if (LEGACY_CONTRACT_TYPE_TO_SERIES[value]) return LEGACY_CONTRACT_TYPE_TO_SERIES[value];
  if ((CONTRACT_TYPE_SERIES_OPTIONS as readonly string[]).includes(value)) return value;
  for (const rule of SERIES_KEYWORD_RULES) {
    if (rule.patterns.some(pattern => pattern.test(value))) return rule.series;
  }
  return '其他或混合合同';
}

/**
 * 从识别结果中提取「具体类型名」（若本身已是系列则返回空）。
 */
export function resolveContractTypeSpecific(recognizedType: string): string {
  const value = String(recognizedType ?? '').trim();
  if (!value || value === SYSTEM_AUTO_CONTRACT_TYPE) return '';
  if ((CONTRACT_TYPE_SERIES_OPTIONS as readonly string[]).includes(value)) return '';
  return value;
}

/**
 * 预览/界面展示：系列 · 具体识别名。
 */
export function formatContractTypePreviewLabel(series: string, specificType: string): string {
  const seriesLabel = String(series ?? '').trim();
  const specific = String(specificType ?? '').trim();
  if (!seriesLabel && !specific) return '—';
  if (!seriesLabel) return specific;
  if (!specific || specific === seriesLabel) return seriesLabel;
  return `${seriesLabel} · ${specific}`;
}

const SERIES_MENTION_PATTERN = new RegExp(
  (CONTRACT_TYPE_SERIES_OPTIONS as readonly string[])
    .slice()
    .sort((left, right) => right.length - left.length)
    .map(item => item.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&'))
    .join('|'),
  'gu',
);

/**
 * 将预审说明中的系列名称与映射结果对齐，避免模型把股份转让写成买卖合同系列。
 */
export function alignContractTypeAnalysisWithSeries(recognizedType: string, analysis: string): string {
  const series = resolveContractTypeSeries(recognizedType);
  const text = String(analysis ?? '').trim();
  if (!series || !text) return text;
  const replaced = text.replace(SERIES_MENTION_PATTERN, series);
  if (replaced !== text) return replaced;
  return text;
}

const LEGAL_INSTRUMENT_PATTERN = /法律意见书|律师函|尽职调查|尽调报告|法律备忘录|情况报告|工作汇报|会议纪要|案件情况/u;

const LEGAL_INSTRUMENT_LABELS: Array<{pattern: RegExp; label: string}> = [
  {pattern: /法律意见书/u, label: '法律意见书'},
  {pattern: /律师函/u, label: '律师函'},
  {pattern: /尽职调查|尽调报告/u, label: '尽职调查报告'},
  {pattern: /法律备忘录/u, label: '法律备忘录'},
  {pattern: /案件情况报告|情况报告/u, label: '情况报告'},
  {pattern: /工作汇报/u, label: '工作汇报'},
  {pattern: /会议纪要/u, label: '会议纪要'},
];

/** 是否为法律意见书、尽调报告等非合同文本名称。 */
export function isLegalInstrumentLabel(type: string): boolean {
  return LEGAL_INSTRUMENT_PATTERN.test(String(type ?? '').trim());
}

/**
 * 从文件名、识别类型或预审说明中提取法律文件形式（非合同文本）。
 */
export function resolveLegalInstrumentSpecific(context: ContractTypeSeriesContext): string {
  const haystack = [
    context.recognizedType,
    context.fileName,
    context.analysis,
    String(context.text ?? '').slice(0, 2_000),
  ].filter(Boolean).join('\n');
  for (const item of LEGAL_INSTRUMENT_LABELS) {
    if (item.pattern.test(haystack)) return item.label;
  }
  return '';
}

export type ContractTypeSeriesContext = {
  recognizedType?: string;
  fileName?: string;
  analysis?: string;
  text?: string;
};

/** 只识别本文件的类型/标题，不把正文引用的原合同或调解条款当成文件类型。 */
export function resolveSettlementContractType(context: ContractTypeSeriesContext): string {
  const recognized = String(context.recognizedType ?? '').trim();
  const fileName = String(context.fileName ?? '').trim();
  if (isLegalInstrumentLabel(recognized) || isLegalInstrumentLabel(fileName)) return '';
  const typeMatch = recognized.match(/^(?:争议解决类[·、：:\s]*)?(执行和解协议|和解协议|调解协议)(?:$|[（(·])/u);
  if (typeMatch) return typeMatch[1];
  const title = fileName.replace(/\.[^.]+$/u, '').replace(/^\s*\d+[、.．\s]+/u, '');
  const titleMatch = title.match(/^(执行和解协议|和解协议|调解协议)(?:$|[（(\s])/u)
    ?? title.match(/(?:^|[）)\s])(执行和解协议|和解协议|调解协议)$/u);
  if (titleMatch) return titleMatch[1];
  // 没有明确识别结果/文件标题时，正文首个非空行只能是独立标题。
  if (!recognized || recognized === '其他合同' || recognized === OTHER_MIXED_SERIES_CONTRACT_TYPE) {
    const firstLine = String(context.text ?? '').trim().split(/\r?\n/u)[0]?.trim();
    return firstLine?.match(/^(执行和解协议|和解协议|调解协议)$/u)?.[1] ?? '';
  }
  return '';
}

/** 保留手动选择的系列；自动识别/其他系列下保留调解、和解这一专项子类型。 */
export function resolveReviewContractType(configuredType: string, context: ContractTypeSeriesContext): string {
  const configured = String(configuredType ?? '').trim();
  if (!configured || configured === SYSTEM_AUTO_CONTRACT_TYPE) {
    return resolveSettlementContractType(context) || String(context.recognizedType ?? '').trim();
  }
  if (configured === OTHER_MIXED_SERIES_CONTRACT_TYPE || configured === '其他合同') {
    return resolveSettlementContractType(context) || configured;
  }
  return configured;
}

/**
 * 结合文件名、预审说明和正文推断审核系列；非合同文本仍按所涉交易推荐系列。
 */
export function resolveContractTypeSeriesFromContext(context: ContractTypeSeriesContext): string {
  if (resolveSettlementContractType(context)) return OTHER_MIXED_SERIES_CONTRACT_TYPE;
  const recognized = String(context.recognizedType ?? '').trim();
  const fileName = String(context.fileName ?? '').trim();
  const direct = recognized ? resolveContractTypeSeries(recognized) : '';
  if (fileName && /合同|协议/u.test(fileName)) {
    for (const rule of SERIES_KEYWORD_RULES) {
      if (rule.patterns.some(pattern => pattern.test(fileName))) {
        // “建设工程检测/监测/咨询合同”中的建设工程只是服务场景；
        // 若全文已识别为技术/服务合同，不能被文件名背景词覆盖。
        if (direct === '承揽、技术与服务合同系列' && rule.series === '建设工程系列合同') return direct;
        return rule.series;
      }
    }
  }
  if (direct && direct !== '其他或混合合同') return direct;
  const haystack = [
    recognized,
    fileName,
    context.analysis,
    String(context.text ?? '').slice(0, 8_000),
  ].filter(Boolean).join('\n');
  if (!haystack.trim()) return direct || '其他或混合合同';
  for (const rule of SERIES_KEYWORD_RULES) {
    if (rule.patterns.some(pattern => pattern.test(haystack))) return rule.series;
  }
  return direct || '其他或混合合同';
}

/** 系列对应的默认审核合同类型，供非合同文本启用专项规则。 */
export function defaultReviewContractTypeForSeries(series: string): string {
  const value = String(series ?? '').trim();
  if (value === EQUITY_GOVERNANCE_SERIES_CONTRACT_TYPE) return '股权转让合同';
  if (value === SALE_SERIES_CONTRACT_TYPE) return '买卖合同';
  if (value === CONSTRUCTION_SERIES_CONTRACT_TYPE) return '建设工程合同';
  if (value === '租赁与融资租赁系列') return '租赁合同';
  if (value === SERVICE_SERIES_CONTRACT_TYPE) return '服务合同';
  if (value === MANDATE_SERIES_CONTRACT_TYPE) return '委托合同';
  if (value === FINANCE_SERIES_CONTRACT_TYPE) return '借款合同';
  if (value === LOGISTICS_SERIES_CONTRACT_TYPE) return '运输合同';
  if (value === SPECIAL_LAW_SERIES_CONTRACT_TYPE) return '劳动合同';
  if (value === OTHER_MIXED_SERIES_CONTRACT_TYPE) return '其他合同';
  if (value === NON_CONTRACT_DOCUMENT_SERIES) return NON_CONTRACT_DOCUMENT_SERIES;
  return value;
}

/**
 * 预览展示与审核引擎使用的合同类型：非合同文本保留文件形式，审核类型改用所涉交易。
 */
export function buildContractTypePreviewPartsFromContext(context: ContractTypeSeriesContext): {
  series: string;
  specific: string;
  label: string;
  reviewContractType: string;
} {
  const settlement = resolveSettlementContractType(context);
  if (settlement) {
    return {
      series: OTHER_MIXED_SERIES_CONTRACT_TYPE,
      specific: settlement,
      label: formatContractTypePreviewLabel(OTHER_MIXED_SERIES_CONTRACT_TYPE, settlement),
      reviewContractType: settlement,
    };
  }
  const recognized = String(context.recognizedType ?? '').trim();
  const instrument = resolveLegalInstrumentSpecific(context);
  const series = resolveContractTypeSeriesFromContext(context);
  const specific = instrument
    || (recognized && recognized !== '其他合同' && recognized !== '其他或混合合同'
      ? (resolveContractTypeSpecific(recognized) || recognized)
      : '');
  const keepRecognizedForReview = Boolean(
    recognized
    && recognized !== '其他合同'
    && recognized !== '其他或混合合同'
    && !isLegalInstrumentLabel(recognized),
  );
  const reviewContractType = instrument && series && series !== '其他或混合合同'
    ? (keepRecognizedForReview ? recognized : defaultReviewContractTypeForSeries(series))
    : (keepRecognizedForReview ? recognized : defaultReviewContractTypeForSeries(series) || recognized);
  return {
    series,
    specific,
    label: formatContractTypePreviewLabel(series, specific),
    reviewContractType,
  };
}

function appendSeriesRecommendation(series: string, recognizedType: string, analysis: string, instrument = ''): string {
  const text = String(analysis ?? '').trim();
  const seriesLabel = String(series ?? '').trim();
  if (!seriesLabel || seriesLabel === '其他或混合合同') return text;
  const alignKey = instrument || recognizedType;
  if (text.includes(seriesLabel) && (!instrument || text.includes(instrument))) {
    return alignContractTypeAnalysisWithSeries(reviewTypeOrRecognized(alignKey, seriesLabel), text);
  }
  const aligned = alignContractTypeAnalysisWithSeries(reviewTypeOrRecognized(alignKey, seriesLabel), text);
  if (aligned.includes(seriesLabel) && (!instrument || aligned.includes(instrument))) return aligned;
  const instrumentNote = instrument
    ? `文件形式为${instrument}，并非交易合同文本本身；`
    : '';
  const extra = `${instrumentNote}建议按「${seriesLabel}」专项规则审核所涉交易事项。`;
  return aligned ? `${aligned}${aligned.endsWith('。') ? '' : '。'}${extra}` : extra;
}

function reviewTypeOrRecognized(recognizedType: string, series: string): string {
  return isLegalInstrumentLabel(recognizedType) ? defaultReviewContractTypeForSeries(series) : recognizedType;
}

/**
 * 将预审说明与上下文推断的系列对齐，并在非合同文本上补一句推荐系列。
 */
export function alignContractTypeAnalysisWithContext(
  context: ContractTypeSeriesContext,
  analysis: string,
): string {
  const parts = buildContractTypePreviewPartsFromContext(context);
  if (resolveSettlementContractType(context)) {
    // 清理历史重复追加的系列建议，不改写原交易事实；多次执行必须得到同一结果。
    const facts = String(analysis ?? '').trim()
      .replace(/建议按[^。；;\n]{1,100}专项规则审核(?:所涉交易事项)?[。；;]?/gu, '')
      .trim();
    const recommendation = '建议按和解/调解协议专项规则审核。';
    return facts ? `${facts}${/[。；;]$/u.test(facts) ? '' : '。'}${recommendation}` : recommendation;
  }
  return appendSeriesRecommendation(
    parts.series,
    String(context.recognizedType ?? '').trim(),
    analysis,
    parts.specific && isLegalInstrumentLabel(parts.specific) ? parts.specific : '',
  );
}

/**
 * 根据识别类型生成预览用的系列 + 具体名。
 */
export function buildContractTypePreviewParts(recognizedType: string): {series: string; specific: string; label: string} {
  const series = resolveContractTypeSeries(recognizedType);
  const specific = resolveContractTypeSpecific(recognizedType);
  return {
    series,
    specific,
    label: formatContractTypePreviewLabel(series, specific),
  };
}

/**
 * 将预审识别结果映射为任务/项目设置下拉框应选中的合同类型系列。
 * @param context 识别类型、文件名、说明与正文片段
 */
export function resolveContractTypeSeriesForSettings(context: ContractTypeSeriesContext): string {
  const series = resolveContractTypeSeriesFromContext(context);
  if ((CONTRACT_TYPE_SERIES_OPTIONS as readonly string[]).includes(series)) return series;
  const recognized = String(context.recognizedType ?? '').trim();
  if (!recognized || recognized === SYSTEM_AUTO_CONTRACT_TYPE) return series || recognized;
  const mapped = LEGACY_CONTRACT_TYPE_TO_SERIES[recognized] ?? resolveContractTypeSeries(recognized);
  if ((CONTRACT_TYPE_SERIES_OPTIONS as readonly string[]).includes(mapped)) return mapped;
  if ((CONTRACT_TYPE_SERIES_OPTIONS as readonly string[]).includes(recognized)) return recognized;
  return series || mapped || recognized;
}
